import axios from 'axios'
import 'url-search-params-polyfill'

import apiConfiguration from '../utilities/api/apiConfiguration'
import setActiveStep from './activeStepActions'
import getCookie from '../utilities/session/getCookie'
import eraseCookie from '../utilities/session/removeCookie'
import _ from 'lodash'

export const RECORD_DSP2_TRANSACTION_BEGIN   = 'RECORD_DSP2_TRANSACTION_BEGIN'
export const RECORD_DSP2_TRANSACTION_SUCCESS = 'RECORD_DSP2_TRANSACTION_SUCCESS'
export const RECORD_DSP2_TRANSACTION_FAILURE = 'RECORD_DSP2_TRANSACTION_FAILURE'

export const recordDsp2TransactionBegin = () => ({
	type: RECORD_DSP2_TRANSACTION_BEGIN,
})

export const recordDsp2TransactionSuccess = dsp2Data => ({
	type: RECORD_DSP2_TRANSACTION_SUCCESS,
	payload: dsp2Data
})

export const recordDsp2TransactionError = error => ({
	type: RECORD_DSP2_TRANSACTION_FAILURE,
	payload: { error }
})

// Handle Availability Fetch & Functionality
export default function recordDsp2Transaction(bookingId, pspTransactionToken, handleDsp2ApiError) {
	if (window.cardinal) {
		window.cardinal.off('payments.validated')
	}
	return (dispatch, getState) => {
		const urlData = getState().availabilityData.urlData
		const activeStep = getState().activeStepData.activeStep

		let clientId = null

		if (
			process.env.REACT_APP_FLOW_CLIENT_ID &&
			process.env.REACT_APP_FLOW_CLIENT_ID !== 'null'
		) {
			clientId = process.env.REACT_APP_FLOW_CLIENT_ID
		}

		let sessionId = ''

		if (
			getCookie('flowSessionId') &&
			getCookie('flowSessionId') !== ''
		) {
			sessionId = getCookie('flowSessionId')
		}

		let hotelProvider = _.get(urlData, 'hotelProvider', '0')

		// URL Params
		let urlParams = {
			clientId: clientId,
			hotelProvider: hotelProvider,
			sessionId: sessionId,
		}

		// Fetch Query string method
		const fetchQuery = new URLSearchParams()

		// Loop urlParams for undefined values & remove
		for (let key in urlParams) {
			if (typeof urlParams[key] === "undefined") continue
			fetchQuery.append(key, urlParams[key])
		}

		const confirmationPayload = {
			createPaymentConfirmationParameters: [
				{
					id: bookingId,
					pspTransactionToken: pspTransactionToken
				}
			]
		}

		// Base API path
		const recordTransactionApi = process.env.REACT_APP_FLOW_ENDPOINT_URL + '/api/hotel/payment-confirmation?' + fetchQuery.toString()

		dispatch(recordDsp2TransactionBegin())
		return axios.post(recordTransactionApi, JSON.stringify(confirmationPayload), apiConfiguration())
			.then((response) => {
				const res = _.get(response, 'data["hydra:member"][0]', [])
				const isDsp2PaymentSuccessful = _.get(res, 'status', null)

				if (
					isDsp2PaymentSuccessful &&
					isDsp2PaymentSuccessful === 'OK'
				) {
					dispatch(recordDsp2TransactionSuccess(res))
					dispatch(setActiveStep(activeStep + 1))
					eraseCookie('flowSessionId')
				} else {
					handleDsp2ApiError(`Transaction Failed (DSP2) - ${isDsp2PaymentSuccessful}`)
					dispatch(recordDsp2TransactionError('Transaction Failed (DSP2)'))
				}
			})
			.catch(error => {
				handleDsp2ApiError(`Transaction Failed (DSP2) - ${error}`)
				dispatch(recordDsp2TransactionError(error))
			})
	}
}


// WEBPACK FOOTER //
// ./src/actions/recordDsp2Transaction.js